import React, { useState, useEffect,useRef } from 'react';
import EditAutocomplete from '../common/editAutoComplete/editAutoComplete';
import AccountLoader from '../manageAccount/accountLoader';
import { apiUrl } from '../common/constants';
import { GetRequest, getparamsString } from '../common/helper';
import AlertSuccess from '../common/alertSuccess';
import { renderImg } from '../common/icons/img';
import AlertFail from '../common/alertFail';
import { t, SELECT_BOARDING_POINT, SELECT_DROPPING_POINT, CANCEL, MODIFY, MODIFICATION_FAILED, THE_TICKET_NON_EDITABLE, GO_BACK_TO_HOME, BOOKING_MODIFIED, PICKUP_DROPOFF, SAVED_SUCCESSFULLY } from '../../translations/Edit';

const Edit = (props) => {
    const { routeID, defPickup, defDropOff, BookingRefNo, PNR, cancel } = props;
    const [openPickupDrop, setOpenPickupDrop] = useState(false);
    const [openDropOffDrop, setOpenDropOffDrop] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selPickupData, setSelPickUpData] = useState(defPickup);
    const [selDropOffData, setSelDropOffData] = useState(defDropOff);
    const [editSuccess, setEditSuccess] = useState(false);
    const [editFailed, setEditFailed] = useState(false);
    const myRef = useRef(null);

    // const resp = {
    //     "pickups": [
    //         {
    //             "Address": "",
    //             "CityID": 1661,
    //             "ContactNumbers": "",
    //             "Landmark": "",
    //             "PickupChargePer": 0,
    //             "PickupChargeRs": 0,
    //             "PickupID": 5,
    //             "PickupLinkCityId": 0,
    //             "PickupLinkCityName": "",
    //             "PickupName": "BENGALURU",
    //             "PickupTime": "2024-04-04 06:00:00 am"
    //         },
    //         {
    //             "Address": "",
    //             "CityID": 1661,
    //             "ContactNumbers": "",
    //             "Landmark": "",
    //             "PickupChargePer": 0,
    //             "PickupChargeRs": 0,
    //             "PickupID": 117,
    //             "PickupLinkCityId": 0,
    //             "PickupLinkCityName": "",
    //             "PickupName": "KEMPEGOWDA BS TERMINAL 2",
    //             "PickupTime": "2024-04-04 06:05:00 am"
    //         },
    //         {
    //             "Address": "",
    //             "CityID": 1661,
    //             "ContactNumbers": "",
    //             "Landmark": "",
    //             "PickupChargePer": 0,
    //             "PickupChargeRs": 0,
    //             "PickupID": 93,
    //             "PickupLinkCityId": 0,
    //             "PickupLinkCityName": "",
    //             "PickupName": "Navarang Park",
    //             "PickupTime": "2024-04-04 06:10:00 am"
    //         },
    //         {
    //             "Address": "",
    //             "CityID": 1661,
    //             "ContactNumbers": "",
    //             "Landmark": "",
    //             "PickupChargePer": 0,
    //             "PickupChargeRs": 0,
    //             "PickupID": 118,
    //             "PickupLinkCityId": 0,
    //             "PickupLinkCityName": "",
    //             "PickupName": "YESHWANTPUR GOVARDHAN THEATER",
    //             "PickupTime": "2024-04-04 06:15:00 am"
    //         },
    //         {
    //             "Address": "",
    //             "CityID": 1661,
    //             "ContactNumbers": "",
    //             "Landmark": "",
    //             "PickupChargePer": 0,
    //             "PickupChargeRs": 0,
    //             "PickupID": 95,
    //             "PickupLinkCityId": 0,
    //             "PickupLinkCityName": "",
    //             "PickupName": "GORAGUNTEPALYA KLE DENTAL COLG",
    //             "PickupTime": "2024-04-04 06:20:00 am"
    //         }
    //     ],
    //     "cnclDetails": {
    //         "100%": "2 hrs ",
    //         "50%": "1 days ",
    //         "25%": "3 days ",
    //         "10%": "31 days "
    //     },
    //     "dropPoints": [
    //         {
    //             "DropLinkCityID": 0,
    //             "DropLinkCityName": "",
    //             "DropoffChargePer": 0,
    //             "DropoffChargeRs": 0,
    //             "DropoffID": 9,
    //             "DropoffName": "SHIVAMOGGA",
    //             "DropoffTime": "2024-04-04 12:30:00 pm"
    //         }
    //     ]
    // }

    const [pickupData, setPickupData] = useState([])
    const [dropOffData, setDropOffData] = useState([]);

    useEffect(() => {
        setLoader(true);
        const data = {
            routeID: routeID
        }
        const url = apiUrl.routeInfo + "?" + getparamsString(data);
        GetRequest(url)
            .then((res) => {
                setLoader(false);
                if (res.pickups) {
                    setPickupData(res.pickups)
                }
                if (res.dropPoints) {
                    setDropOffData(res.dropPoints)
                }
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            });
    }, [])

    const handlePickDrop = (id, name, type) => {
        console.log({ id, name, type })
        if (type === 'pickup') {
            setSelPickUpData({ id, name })
            setOpenPickupDrop(false)
        } else {
            setSelDropOffData({ id, name })
            setOpenDropOffDrop(false)
        }
    }

    const getPickupData = (data) => {
        let pickUp = [];
        if (data && data.length > 0) {
            pickUp = data.map(el => ({ id: el.PickupID, name: el.PickupName }))
        }

        return pickUp;
    }

    const getDropOffData = (data) => {
        let dropOff = [];
        if (data && data.length > 0) {
            dropOff = data.map(el => ({ id: el.DropoffID, name: el.DropoffName }))
        }
        return dropOff;
    }


    const handleEditBooking = () => {
        console.log({ selPickupData, selDropOffData, BookingRefNo, PNR })
        const data = {
            strPNRNo: BookingRefNo,
            PickupID: selPickupData.id,
            DropoffID: selDropOffData.id,
        };
        setLoader(true)
        const url = apiUrl.editBooking + "?" + getparamsString(data);
        GetRequest(url)
            .then((res) => {
                setLoader(false)
                console.log(res);
                if (res.IsSuccess && !res.ErrorMessage) {
                    setEditSuccess(true);
                } else {
                    setEditFailed(true);
                }
            })
            .catch((err) => {
                setLoader(false);
                console.log(err);
            });
    };

    useEffect(()=>{
        myRef.current.style.marginBottom = '40px';
        setTimeout(() => {
          myRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    },[])

    return (
        <>
            {loader && <AccountLoader />}
            <div ref = {myRef}></div>
            <div className='edit--wrapper' style={{ display: 'flex', marginTop: '32px', background: '#fff' }}>
                <EditAutocomplete
                    type={'pickup'}
                    label={t(SELECT_BOARDING_POINT)}
                    onClick={() => { setOpenPickupDrop(true); setOpenDropOffDrop(false) }}
                    selVal={selPickupData.name}
                    openDrop={openPickupDrop}
                    options={getPickupData(pickupData)}
                    handlePickDrop={handlePickDrop}
                    setOpenPickupDrop={setOpenPickupDrop}
                />
                <EditAutocomplete
                    type={'dropoff'}
                    label={t(SELECT_DROPPING_POINT)}
                    onClick={() => { setOpenDropOffDrop(true); setOpenPickupDrop(false); }}
                    selVal={selDropOffData.name}
                    openDrop={openDropOffDrop}
                    options={getDropOffData(dropOffData)}
                    handlePickDrop={handlePickDrop}
                    setOpenDropOffDrop={setOpenDropOffDrop}
                />
            </div>
            <div className='edit--button--wrapper'>
                <div onClick={() => cancel()}>{t(CANCEL)}</div>
                <div onClick={handleEditBooking}>{t(MODIFY)}</div>
            </div>

            {editSuccess && <AlertSuccess
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('success_icon')}
                        </div>
                        <div style={{ color: '#3C763C', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '8px 0 8px 0' }}>{t(BOOKING_MODIFIED)}</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            {t(PICKUP_DROPOFF)} <br /> {t(SAVED_SUCCESSFULLY)}
                        </div>
                    </div>
                }
            />}

            {editFailed && <AlertFail
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('fail_icon')}
                        </div>
                        <div style={{ color: '#F05924', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '8px 0' }}>{t(MODIFICATION_FAILED)}</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            {t(THE_TICKET_NON_EDITABLE)}.
                        </div>
                    </div>
                }
            />}
        </>
    )
}
export default Edit;